import React from "react";
import "./achievementComponent.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';

import image1 from "./images/HACK4JUSTICE1.jpeg";
import image2 from "./images/HACK4JUSTICE2.jpeg";
import image3 from "./images/HACK4JUSTICE3.jpeg" ;
import image4 from "./images/HACK4JUSTICE4.jpeg" ;





const Hack4Justice = () => {
    const images = [image1,image2, image3, image4];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">HACK4JUSTICE</h2>
        <span className="section__subtitle">First place winner🥇</span>
        <OptimizedSlideshow mediaItems={images} />
        
        <div className="about__container container grid">
           

            <div className="text__container1">
                <h3 className="title">Description:</h3>
                <br />
                <p className='redRadio__text'>Winner of Hack4Justice, a national AI hackathon focused on improving access to justice for MSMEs in Tunisia. Our team, Spartans, developed an AI-driven legal information platform designed to make business and registration data more accessible to entrepreneurs. The project was selected for real-world deployment by the Registre National des Entreprises (RNE), marking a tangible step toward people-centered digital transformation in the Tunisian legal ecosystem.</p>

            </div>
        </div>
    </section>
    );
};

export default Hack4Justice;
